// extracted by mini-css-extract-plugin
export var bold = "_xg-0";